import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { asociarLandingPaqueteAction, obtenerLandingPaqueteAction, eliminarLandingPaqueteAction, obtenerLandingHabilitadosAction } from '../../../ducks/landingDuck'
import { offLoadAction, onLoadAnction } from '../../../ducks/loadDuck';
export default function ListaCheck() {
    const { clavePaquete, listLandingPagePaquete, listLandingHabilitados } = useSelector(store => store.landing)
    const dispatch = useDispatch()
    const handleChange = (event) => {
        const indexPagePaquete = listLandingPagePaquete.findIndex((element) => element?.Landing?.IdLanding === Number(event.target.name))
        if (indexPagePaquete >= 0) {
            const idPaqueteLanding = listLandingPagePaquete[indexPagePaquete]?.IdPaqueteLanding
            dispatch(onLoadAnction({ message: "" }))
            dispatch(eliminarLandingPaqueteAction({ IdPaqueteLanding: idPaqueteLanding })).then(Response => {
                dispatch(obtenerLandingPaqueteAction({ClavePaquete: clavePaquete }))
                dispatch(obtenerLandingHabilitadosAction())
                dispatch(offLoadAction())
            })
        }
        if (indexPagePaquete === -1) {
            dispatch(onLoadAnction({ message: "" }))
            dispatch(asociarLandingPaqueteAction({ ClavePaquete: clavePaquete, IdLanding: event.target.name })).then(Response => {
                dispatch(obtenerLandingPaqueteAction({ClavePaquete: clavePaquete }))
                dispatch(obtenerLandingHabilitadosAction())
                dispatch(offLoadAction())
            })
        }
    }
    const validarCheck = (idLanding) => {
        const busqueda = (element) => element?.Landing?.IdLanding === Number(idLanding)
        const indexPagePaquete = listLandingPagePaquete.findIndex(busqueda)
        if (indexPagePaquete === -1) {
            return false
        }
        return true
    }
    return (
        <FormGroup row>
            {
                listLandingHabilitados.map(landing =>
                    <FormControlLabel
                        key={landing.IdLanding}
                        control={
                            <Checkbox
                                checked={validarCheck(landing.IdLanding)}
                                onChange={(event) => handleChange(event)}
                                name={`${landing.IdLanding}`}
                            />
                        }
                        label={`${landing.Nombre}`}
                    />
                )
            }

        </FormGroup>
    )
}